import React, { Component } from 'react';
import { connect } from 'react-redux';
import { detect } from 'detect-browser';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import { sessionType } from '../../../types';
import handleKeyPress from '../../../common/handleKeyPress';
import { request } from '../../../common/request';
import configs from '../../../constants/configs';

class Feedback extends Component {
    state = {
        mouseOverElement: '',
        feedbackText: '',
        feedbackSubmitted: false,
    };

    render() {
        const { open, setOpen, session } = this.props;
        const userEmail = _get(session, 'user.email', 'N/A');
        const userID = _get(session, 'user.userID', 'N/A');
        const { mouseOverElement, feedbackText, feedbackSubmitted } = this.state;
        const title = `Email Designer ${configs.reactAppVersion}`;

        const onSubmitClick = () => {
            if (feedbackText.length > 0) {
                let browser = detect();
                const time = new Date();
                const user = `id: ${userID} - email: ${userEmail}`;
                if (!browser) {
                    browser = {
                        name: 'CANNOT_DETECT',
                        version: 'CANNOT_DETECT',
                        os: 'CANNOT_DETECT',
                    };
                }
                const payload = {
                    browser,
                    time: time.toLocaleString('en-ca'),
                    user,
                    integration: session.integration,
                    feedbackText: `*${'`'}${feedbackText
                        .replace(/`/g, "'")
                        .replace(/_/g, '-')
                        .replace(/\n/, ' ')
                        .replace(/\*/g, '')}${'`'}*`,
                };
                request.post(configs.postPikassoFeedback, payload);
                this.setState({ feedbackSubmitted: true });
                window.setTimeout(() => {
                    setOpen(false);
                    this.setState({ feedbackSubmitted: false, feedbackText: '' });
                }, 2000);
            }
        };

        const onCancelClick = () => {
            setOpen(false);
            this.setState({ feedbackSubmitted: false, feedbackText: '' });
        };

        return (
            <div
                data-test-id="feedback-btn"
                style={{ position: 'absolute', top: 7, right: 48, height: 30, zIndex: 9 }}
                role="dialog"
                aria-labelledby="email-designer-version-title"
                aria-describedby="feedback-modal-description"
            >
                <div
                    style={{
                        position: 'absolute',
                        width: 480,
                        height: 268,
                        top: 44,
                        right: 'calc(50% + 25px)',
                        padding: 6,
                        backgroundColor: 'white',
                        borderRadius: 0,
                        boxShadow: '0 1px 10px 0 rgba(0,0,0,0.25)',
                        display: open ? 'block' : 'none',
                    }}
                >
                    <div style={{ width: 400, margin: '20px auto 0px' }}>
                        {feedbackSubmitted ? (
                            <div style={{ marginTop: 40 }}>
                                <img
                                    draggable="false"
                                    src={`${process.env.PUBLIC_URL}/assets/feedback/thanks.png`}
                                    style={{ display: 'block', height: 130, margin: '0px auto 4px' }}
                                    alt=" thank you for your feedback"
                                />
                                <p
                                    style={{
                                        fontSize: 16,
                                        textAlign: 'center',
                                        color: '#1c1c1c',
                                        height: 20,
                                        lineHeight: '20px',
                                    }}
                                >
                                    Our team has received your message.
                                </p>
                                <p
                                    style={{
                                        fontSize: 16,
                                        textAlign: 'center',
                                        color: '#1c1c1c',
                                        height: 20,
                                        lineHeight: '20px',
                                    }}
                                >
                                    Thanks for your input!
                                </p>
                            </div>
                        ) : (
                            open && (
                                <div>
                                    <p
                                        id="email-designer-version-title"
                                        style={{
                                            fontFamily: "'Caveat', sans-serif",
                                            fontSize: 20,
                                            fontWeight: 600,
                                            color: '#0277bd',
                                            height: 36,
                                            lineHeight: '36px',
                                        }}
                                    >
                                        {title}
                                    </p>
                                    <p id="feedback-modal-description" style={{ fontSize: 16, textAlign: 'justify' }}>
                                        We’d like to hear about your experience, as we strive for improvement. Please
                                        share your thoughts below.
                                    </p>
                                    <textarea
                                        className="scrollFix"
                                        style={{
                                            width: 366,
                                            height: 80,
                                            margin: '12px 0px 16px',
                                            fontSize: 15,
                                            padding: '4px 16px',
                                            outline: 'none',
                                            border: '1px solid #D9DADB',
                                            resize: 'none',
                                        }}
                                        placeholder="Type something here..."
                                        value={feedbackText}
                                        onChange={(event) => this.setState({ feedbackText: event.target.value })}
                                        data-test-id="feedback-text"
                                        // eslint-disable-next-line jsx-a11y/no-autofocus
                                        autoFocus
                                    />
                                    <div
                                        style={{
                                            position: 'absolute',
                                            left: 0,
                                            width: '100%',
                                            height: 1,
                                            backgroundColor: '#d9dadb',
                                        }}
                                    />
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            justifyContent: 'end',
                                            margin: '12px 0',
                                        }}
                                    >
                                        <div
                                            style={{
                                                width: 75,
                                                height: 32,
                                                backgroundColor: mouseOverElement === 'cancel' ? '#f3f8fc' : 'white',
                                                color: '#424242',
                                                cursor: 'pointer',
                                                marginRight: 16,
                                            }}
                                            onMouseOver={() => this.setState({ mouseOverElement: 'cancel' })}
                                            onMouseLeave={() => this.setState({ mouseOverElement: '' })}
                                            onFocus={() => this.setState({ mouseOverElement: 'cancel' })}
                                            onBlur={() => this.setState({ mouseOverElement: '' })}
                                            onClick={() => onCancelClick()}
                                            onKeyDown={(e) => handleKeyPress(e, onCancelClick)}
                                            data-test-id="feedback-cancel"
                                            role="button"
                                            tabIndex="0"
                                        >
                                            <p
                                                style={{
                                                    fontSize: 13,
                                                    fontWeight: 'bold',
                                                    textAlign: 'center',
                                                    height: 32,
                                                    lineHeight: '32px',
                                                }}
                                            >
                                                CANCEL
                                            </p>
                                        </div>
                                        <div
                                            style={{
                                                width: 75,
                                                height: 32,
                                                backgroundColor: mouseOverElement === 'submit' ? '#01579b' : '#0277bd',
                                                color: 'white',
                                                cursor: 'pointer',
                                            }}
                                            onMouseOver={() => this.setState({ mouseOverElement: 'submit' })}
                                            onMouseLeave={() => this.setState({ mouseOverElement: '' })}
                                            onFocus={() => this.setState({ mouseOverElement: 'submit' })}
                                            onBlur={() => this.setState({ mouseOverElement: '' })}
                                            onClick={() => onSubmitClick()}
                                            onKeyDown={(e) => handleKeyPress(e, onSubmitClick)}
                                            data-test-id="feedback-submit"
                                            role="button"
                                            tabIndex="0"
                                        >
                                            <p
                                                style={{
                                                    fontSize: 13,
                                                    fontWeight: 'bold',
                                                    textAlign: 'center',
                                                    height: 32,
                                                    lineHeight: '32px',
                                                }}
                                            >
                                                SUBMIT
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            )
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    session: state.session,
});

Feedback.propTypes = {
    open: PropTypes.bool.isRequired,
    setOpen: PropTypes.func.isRequired,
    session: sessionType.isRequired,
};

export default connect(mapStateToProps)(Feedback);
